import Button from '@blocks/Button'
import { route } from '@helpers'
import { Box } from '@styles/helpers'
import { mTablet, tablet } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

const ParticipatingSalon = ({ data }: ArchiveComponentProps<Interfaces.Salon>) => {
    const { id, name, slug, background_url } = data
    return (
        <Box narrow={true}>
            <Wrapper>
                <Link to={route("customer:salon", id)}><Image src={background_url} /></Link>
                <Content>
                    <Link to={route("customer:salon", id)}><h2>{name}</h2></Link>
                    <Buttons>
                        <Button to={route("customer:salon", id)}>My Entry</Button>
                        <Button type="secondary" width="auto" to={route("general:salon:status", slug)}>Status List</Button>
                    </Buttons>
                </Content>
            </Wrapper>
        </Box>
    )
}

export default React.memo(ParticipatingSalon)

/* STYLES */
const Wrapper = styled.div`
    a {
        text-decoration: none;
    }

    ${tablet(css`
        display: grid;
        grid-template-columns: 200px minmax(0, auto);
        grid-gap: 30px;
    `)}
`

const Content = styled.div`
    & > a {
        display: block;
        margin-bottom: 15px;
    }

    ${tablet(css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 20px 0;
    `)}
`

const Buttons = styled.div`
    & > div:not(:last-child) {
        margin-bottom: 10px;
    }

    ${mTablet(css`
        display: flex;

        & > div:not(:last-child) {
            margin-bottom: 0;
            margin-right: 20px;
        }

        & > div:first-child {
            max-width: 250px;
        }
    `)}
`

const Image = styled.div<{ src: string }>`
    height: 200px;
    width: 100%;
    background: ${props => props.src ? "url(" + props.src + ") center center no-repeat" : colors.greyBackground};
    background-size: cover;
    border-radius: 10px;
    margin-bottom: 15px;

    ${tablet(css`
        min-height: 200px;
        height: 100%;
        width: 200px;
        margin-bottom: 0;
    `)}
`